module.exports = __webpack_public_path__ + "static/media/calendar.12ef4519.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/icons/calendar.svg
// module id = 2522
// module chunks = 7